import { render, staticRenderFns } from "./switch-block.vue?vue&type=template&id=b220fb0a&scoped=true&"
import script from "./switch-block.vue?vue&type=script&lang=js&"
export * from "./switch-block.vue?vue&type=script&lang=js&"
import style0 from "./switch-block.vue?vue&type=style&index=0&id=b220fb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b220fb0a",
  null
  
)

export default component.exports